import { useEffect, useRef, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function CreditAlertBanner() {
  const { activeWorkspace } = useAuth();
  const [credits, setCredits] = useState(null);
  const lastToasted = useRef({});

  useEffect(() => {
    if (!activeWorkspace) return;
    api.get("/billing/credits").then(({ data }) => {
      setCredits(data);
      const key = activeWorkspace.id;
      if (data.alert_level !== "none" && lastToasted.current[key] !== data.alert_level) {
        lastToasted.current[key] = data.alert_level;
        if (data.alert_level === "critical") {
          toast.error(`Only ${data.percentage_remaining}% of your credits remain — time to top up now!`, { duration: 6000 });
        } else if (data.alert_level === "warning") {
          toast.warning(`Credits running low (${data.percentage_remaining}% left) — consider topping up soon.`, { duration: 6000 });
        }
      }
    });
  }, [activeWorkspace]);

  if (!credits || credits.alert_level === "none") return null;

  const isCritical = credits.alert_level === "critical";

  return (
    <div
      data-testid={`credit-alert-banner-${credits.alert_level}`}
      className={`flex items-center justify-center gap-2 border-b px-4 py-2 text-sm font-medium ${
        isCritical
          ? "border-destructive/30 bg-destructive/10 text-destructive"
          : "border-amber-300/40 bg-amber-50 text-amber-700 dark:bg-amber-950/30 dark:text-amber-300"
      }`}
    >
      <AlertTriangle className="h-4 w-4" />
      {isCritical
        ? `Critical: only ${credits.percentage_remaining}% of your credits remain.`
        : `Heads up: ${credits.percentage_remaining}% of your credits remain.`}
      <Link to="/app/billing" className="ml-1 underline underline-offset-2" data-testid="credit-alert-topup-link">
        Top up now
      </Link>
    </div>
  );
}
